export const uk = {
    'empty-custom-period': 'Укажите количество дней',
    'empty-shows-limit': 'Укажите частоту показов'
};
